import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { SettingsProvider } from './Settings';
import { I18nProvider } from './i18n';
import { AppRoutes } from './layouts';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CssBaseline />
      <I18nProvider>
        <SettingsProvider>
          <AppRoutes />
        </SettingsProvider>
      </I18nProvider>
    </BrowserRouter>
  </React.StrictMode>
);
